import { CascadiaJsonFormContext } from "@certn/forms";
import { ArrayControlProps } from "@jsonforms/core";
import { withJsonFormsArrayControlProps } from "@jsonforms/react";
import { useContext } from "react";

import { GapHistoryControl } from "./GapHistoryControl";
import { GapHistorySummaryControl } from "./GapHistorySummaryControl";

function GapHistoryControlInternal(props: ArrayControlProps) {
  const { isSummary } = useContext(CascadiaJsonFormContext);

  if (isSummary) {
    return <GapHistorySummaryControl {...props} />;
  }

  return <GapHistoryControl {...props} />;
}

export const GapHistoryControlRenderer = withJsonFormsArrayControlProps(
  GapHistoryControlInternal
);
